import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../services/data-core.service';
import { BYS_GetIcBirimlerListe, BYS_GetIcBirimlerListe_Response } from 'libs/bys/src/lib/models/dtos';
 import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../../services/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class CtlBirimTurTreeService {

     constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {}



  getDataSource(birimTuru: string) {
    const dataSource = this.dataCoreService.getOData('GenBirim');
    dataSource.select([]);

    const filterArr = [];
    if (birimTuru) {
      filterArr.push(['BirimTuru', '=', birimTuru]);
    }

    if (filterArr.length > 0) {
      dataSource.filter(filterArr);
    }

    return dataSource;
  }

  getIcBirimlerList(belgeKod:number){
    const request=new BYS_GetIcBirimlerListe({
      piBelgeKod:belgeKod
    });
    return this._httpClient.post<BYS_GetIcBirimlerListe_Response>(`${environment.bysService}api/BYS_GetIcBirimlerListe`, request).pipe(
      map((res) => {
        return res as BYS_GetIcBirimlerListe_Response;
      }))
  }
}
